export enum GenericModalOptions {
    ShowCodeBlock,
    ShowParagraph,
    ShowHtml,
    ShowJson
  }
